import { Instagram, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" className="h-8 w-8" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SocialCard = ({ href, testid, icon: Icon, network, handle, note, delay }) => (
  <Reveal delay={delay}>
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-edge bg-ink2 p-8 transition-colors duration-300 hover:border-crimson/60"
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-crimson/15 blur-3xl transition-opacity group-hover:opacity-100" />
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-crimson text-white transition-transform duration-300 group-hover:scale-110">
        <Icon />
      </div>
      <p className="font-display text-2xl font-extrabold uppercase text-white">{network}</p>
      <p className="mt-1 font-mono-score text-sm text-glow">{handle}</p>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">{note}</p>
      <span className="mt-auto flex items-center gap-2 pt-6 font-display text-base font-bold uppercase tracking-wider text-crimson">
        Abrir perfil
        <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
      </span>
    </a>
  </Reveal>
);

const Contacto = () => (
  <div className="bg-ink pt-32" data-testid="contacto-page">
    <div className="mx-auto max-w-4xl px-5 pb-24 md:px-12">
      <Reveal>
        <p className="eyebrow mb-3">Contacto y redes</p>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight text-white sm:text-6xl">
          Hablemos de <span className="text-crimson">fútbol</span>
        </h1>
        <p className="mt-4 max-w-xl text-slate-300">
          Colaboraciones, prensa o simplemente charlar del Sporting: encuéntrame en mis redes.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        <SocialCard
          href="https://www.tiktok.com/@enolfc"
          testid="contact-tiktok-link"
          icon={TikTokIcon}
          network="TikTok"
          handle="@ENOLFC"
          note="Reacciones en directo, previas y el humor rojiblanco de cada jornada."
          delay={0.1}
        />
        <SocialCard
          href="https://www.instagram.com/enolfc_"
          testid="contact-instagram-link"
          icon={() => <Instagram className="h-8 w-8" />}
          network="Instagram"
          handle="@ENOLFC_"
          note="Fotos de El Molinón, clips y lo mejor del día a día sportinguista."
          delay={0.2}
        />
      </div>
    </div>
  </div>
);

export default Contacto;
